import { Chip, FormLabel, IconButton, Stack } from "@mui/material"
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft"
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight"

const AcademicYearSelect = ({ value, setValue }) => {
  return (
    <Stack alignItems="center">
      <FormLabel sx={{ fontSize: 14 }}>Academic year</FormLabel>
      <Stack direction="row" alignItems="center" gap={1}>
        <IconButton onClick={() => setValue((val) => val - 1)}>
          <KeyboardArrowLeftIcon />
        </IconButton>
        <Chip label={value + "-" + (parseInt(String(value).slice(-2)) + 1)} />
        <IconButton onClick={() => setValue((val) => val + 1)}>
          <KeyboardArrowRightIcon />
        </IconButton>
      </Stack>
    </Stack>
  )
}

export default AcademicYearSelect
